import { FC } from "react";
import { Box, Typography } from "@mui/material";
import colors from "../../shared/constants/color";

interface GifLoadingProps {
  gifSrc: string;
  alt?: string;
  title?: string;
  description?: string;
  size?: number | string;
  fullscreen?: boolean;
  backdropColor?: string;
  zIndex?: number;
}

const GifLoading: FC<GifLoadingProps> = ({
  gifSrc,
  alt = "Loading",
  title,
  description,
  size = 140,
  fullscreen = false,
  backdropColor = "rgba(250, 250, 250, 0.65)",
  zIndex = 1200,
}) => {
  const content = (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
      <Box
        component="img"
        src={gifSrc}
        alt={alt}
        sx={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
        }}
      />

      {title && (
        <Typography
          fontFamily="Inter"
          fontSize="16px"
          fontWeight={500}
          color={colors.blue.B500}
        >
          {title}
        </Typography>
      )}

      {description && (
        <Typography
          fontFamily="Inter"
          fontSize="12px"
          color={colors.neutral.N400}
          textAlign="center"
        >
          {description}
        </Typography>
      )}
    </Box>
  );

  if (!fullscreen) {
    return content;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: backdropColor,
        zIndex,
      }}
    >
      {content}
    </Box>
  );
};

export default GifLoading;
